import React from 'react';
import PropTypes from 'prop-types';
import {round} from 'lodash';
import TextInput from 'generic/Forms/TextInput/TextInput.react';
import Button from 'sg/Button/Button.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';

export default class CorrectAnswer extends React.Component {
  static propTypes = {
    answer: PropTypes.string,
    inputId: PropTypes.string,
    index: PropTypes.number,
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onModelChange: PropTypes.func
  };

  updateAnswer = (e) => {
    const validResponse = this.props.question
      .getValidResponse()
      .setIn([this.props.inputId, this.props.index], e.target.value);
    const updatedQuestion = this.props.question.setValidResponse(validResponse);

    this.props.onModelChange(updatedQuestion, 'inputs');
  };

  removeAnswer = () => {
    let validResponse = this.props.question
      .getValidResponse()
      .removeIn([this.props.inputId, this.props.index]);

    if (validResponse.get(this.props.inputId).isEmpty()) {
      validResponse = validResponse.remove(this.props.inputId);
    }

    const updatedQuestion = this.props.question.setValidResponse(validResponse);
    this.props.onModelChange(updatedQuestion, 'inputs');
  };

  generateThresholdAcceptance() {
    if (this.props.question.getRubric().get('type') !== 'mathContains' || !this.props.answer) {
      return null;
    }
    const answer = parseFloat(this.props.answer, 10);
    const answerThreshold = answer * (this.props.question.getRubricThreshold() / 100);
    let acceptanceCriteria;
    if (answerThreshold === 0) {
      acceptanceCriteria = 'The answer must match the value provided precisely.';
    } else {
      const min = round(answer - answerThreshold, 5);
      const max = round(answer + answerThreshold, 5);
      acceptanceCriteria = `Acceptance threshold: ${min} thru ${max}`;
    }
    return <small className='free-entry-editor__threshold-acceptance'>{acceptanceCriteria}</small>;
  }

  render() {
    const index = this.props.index;
    const answer = this.props.answer;
    const label = index === 0 ? 'Preferred Answer' : 'Alternative Correct Answer';
    return (
      <div className='free-entry-editor__input-answer'>
        <div className='free-entry-editor__input-answer-item'>
          <TextInput label={label} value={answer} onChange={this.updateAnswer} name='inputAnswer' />
          <Button
            onClick={this.removeAnswer}
            className='fa fa-trash-o'
            color='red'
            outline
            noBorder
          />
        </div>
        {this.generateThresholdAcceptance()}
      </div>
    );
  }
}
